<div class="url-manager-container radius-4">
  <ng-container *ngIf="loading else noLoadingTmpl">
    <div class="text-center">
      <nz-spin nzSimple></nz-spin>
    </div>
  </ng-container>
  <ng-template #noLoadingTmpl>
    <div class="row">
      <div class="col col-12">
        <ng-container *ngIf="hasWritingAccess">
          <button
            type="button"
            class="btn btn-outline-success mr-3"
            (click)="onAddUrl()">New Link</button>
        </ng-container>
        <ng-container *ngFor="let url of urls; let i = index">
          <ng-container *ngIf="hasWritingAccess; else readOnlyTmpl">
            <button
              [value]="url.id"
              type="button"
              class="btn btn-primary ms-1"
              [title]="url.label"
              (click)="redirectUrl(url)"
              (contextmenu)="contextMenu($event, menu)">
              {{ url.label }}</button>
            <button
              type="button"
              title="Delete"
              class="btn btn-outline-danger me-1"
              nz-popconfirm=""
              nzOkText="Yes"
              (nzOnConfirm)="onRemoveUrl(i)"
              nzPopconfirmTitle="Do you want to delete this URL?"
              nzPopconfirmPlacement="bottom">
              <i class="fa fa-times"></i></button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="onEditUrl(i, url)" class="fs-12">Edit</li>
              </ul>
            </nz-dropdown-menu>
          </ng-container>
          <ng-template #readOnlyTmpl>
            <button
              [value]="url.id"
              type="button"
              class="btn btn-primary mx-1"
              [title]="url.label"
              (click)="redirectUrl(url)">
              {{ url.label }}</button>
          </ng-template>
        </ng-container>
      </div>
      <ng-container *ngIf="hasChanges()">
        <div class="col col-12">
          <p class="fs-12 text-danger mt-2 mb-2">Changes were made on the URLs. Please press the "Update" button to apply this changes.</p>
        </div>
      </ng-container>
    </div>
  </ng-template>

</div>
